module.exports = __webpack_public_path__ + "60819f7bbc7f21afbfbc518e1ef45265.fbx";